// extracted by mini-css-extract-plugin
export default {"button":"DashboardDateRangeActions_button__wt9JF"};